import { Field } from "formik";
import * as React from "react";

export function BPFormikFieldCheckbox({ ...fieldProps }) {
    return <>
        <div className="ui checkbox">
            <Field type="checkbox" {...fieldProps} /><label></label>
        </div>
    </>;
}
